import React from 'react';

import { Typography } from 'wanderu-components';

import styles from './RadioButton.scss';

export const RadioButton = ({
    id, text, onChange, checked,
}) => {
    return (
        <label className={styles.field}>
            <input
                checked={checked}
                className={styles.customRadio}
                id={id}
                name="station-map"
                onChange={onChange}
                type="radio"
                value={id}
            />
            <Typography>{text}</Typography>
        </label>
    );
};
